<template>
  <v-row wrap >
    <v-col>
      <v-list
        v-if="visitVehicles"
      >
        <template v-for="(vehicle) in visitVehicles">
          <v-list
            :key="vehicle._id"
            :visitVehicles="visitVehicles"
            :v-if="
              $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item-content :key="vehicle._id">
              <v-list-item slot="activator" >
                <v-col class="col-1">
                  <v-icon color="primary">commute</v-icon>
                </v-col>
                <v-col two-line>
                  <v-list-item-title>
                    {{ vehicle.description }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${resx.labels.domain}: ` }}
                    {{ vehicle.uniqueIdentifier }}
                  </v-list-item-subtitle>
                </v-col>
              </v-list-item>
            </v-list-item-content>
          </v-list>
          <v-divider
            :key="'_' + vehicle._id"
          ></v-divider>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
"use strict";

export default {
  name: "editRateVehiclesDetails",
  props: {
    visitVehicles: { type: Array },
  }
};
</script>
